import React from 'react';
import { useState, useEffect } from 'react';
import barChart from '../../../../assets/icons/bar-chart-square-02.png';
import arrow from '../../../../assets/icons/arrow-up.png';
import search_icon from '../../../../assets/icons/search_icon.png';
import plus from '../../../../assets/icons/plus.png';
import excel_icon from '../../../../assets/icons/excel_icon.png';
import pdf_image from '../../../../assets/icons/pdf_image.png';
import button_icon from '../../../../assets/icons/button_icon.png';
import { Divider, Table } from 'antd';
import * as XLSX from 'xlsx';
import { Navigate, useNavigate } from 'react-router-dom';
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Steps,
  Upload,
  message,
  Select,
  Space,
  Tooltip,
  Modal,
  Spin,
} from 'antd';
import DashboardTable from '../dashboardTable/index.js';
import editReject from '../../../../assets/icons/edit_reject.png';
import check from '../../../../assets/icons/check.png';
import edit_icon from '../../../../assets/icons/edit_icon.png';
import view_icon from '../../../../assets/icons/view_icon.png';
import download_icon from '../../../../assets/icons/download_icon.png';
import tooltip_download from '../../../../assets/icons/tooltip_download.png';
import modal_download from '../../../../assets/icons/Modal_download.png';
import three_dots from '../../../../assets/icons/three_dots_1.png';
import arrow_down from '../../../../assets/icons/arrow_down.png';
import { apiUrl } from '../../../../utilities/apiClient.js';

import {
  getProjectList,
  getBbsList,
  getProjectCount,
  getApproverDashboard,
  getViewProject,
  setProjectData,
  getManagerDashboard,
  createManagerApproveProject,
  createManagerApproveUser,
  createNewBBS,
  setnewBBSData,
  getApproveReject,
  getBBSView,
} from '../../redux/slice.js';
import { getBBSViewFiles } from '../../../bbsOptimization/redux/slice.js';
import { useSelector, useDispatch } from 'react-redux';
import CreateBBSPage from '../createBbs';
import moment from 'moment';
import LocalStorage from '../../../../utilities/localStorage.js';
import DashboardTableManager from '../DashboardTableManager';
import { useParams } from 'react-router-dom';

import { createBBSAlgorithm } from '@features/bbsOptimization/redux/slice';
import { optimizeAlgorithmExport } from '../../../bbsOptimization/components/createBbs/OptimizeAlgorithmExport.js';
import VisualizationTable from '../../../bbsOptimization/components/createBbs/VisualizationTable.js';

const ViewBBS = ({
  isExistingBBS,
  setIsExistingBBS,
  currpage,
  setCurrPage,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [remainingBbs, setRemainingBbs] = useState([]);
  const [selectedBbs, setSelectedBbs] = useState(null);
  const [dataToSend, setDataToSend] = useState(null);
  const [showRemaining, setShowRemaining] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [consolidatedData, setConsolidatedData] = useState([]);
  const [pdfDownloadLoading, setPdfDownloadLoading] = useState(false);
  const [inputFiles, setInputFiles] = useState([]);
  const [results, setResults] = useState([]);
  const [downloading, setDownloading] = useState('');
  const [downloadingIndex, setDownloadingIndex] = useState(null);

  const user_details = LocalStorage.getItem('bbs_user');
  const navigate = useNavigate();
  const { id } = useParams(); // Get ID from the URL
  const { BBSView, loading } = useSelector((state) => state.projectList);
  const { bbsViewFiles, bbsAlgorithmResult } = useSelector(
    (state) => state.bbsOptimise,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    console.log(
      'bbsAlgorithmResultinmyviewpage just ot see:',
      bbsAlgorithmResult,
    );
  }, [bbsAlgorithmResult]);

  console.log('BBSView:', BBSView);
  const dataSource = Array.isArray(BBSView)
    ? BBSView
    : BBSView
      ? [BBSView]
      : [];
  console.log('datasource: ', dataSource);

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedBbs(null);
  };
  const toggleRemaining = () => {
    setShowRemaining(!showRemaining);
  };

  const handleConfirm = () => {
    console.log('Download Mapping Sheet'); // Add your logic here
    setIsModalVisible(false);
  };

  const handleBbsClick1 = (bbs, projectCode) => {
    console.log('BBS Clicked@@@@@@:', bbs); // Log the clicked BBS data
    console.log('BBS ProjectCode:', projectCode); // Log the clicked BBS data
    setSelectedBbs({ bbs, projectCode }); // Store the clicked BBS data
    console.log('selectedBbs immediately after setSelectedBbs:', selectedBbs);
    setIsModalVisible(true); // Show the modal

    const params = {
      bbsId: bbs,
      project_code: projectCode,
      type: 'raw-data',
    };

    dispatch(getBBSViewFiles(params))
      .then((res) => {
        console.log('BBS Algorithm Result:', res.payload);
        if (res.payload?.success) {
          const { results, input_files } = res.payload;

          setResults(results);
          setInputFiles(Array.isArray(input_files) ? input_files : []);

          //optimizeAlgorithmExport(results);
        } else {
          console.error('Backend response does not indicate success.');
        }
      })
      .catch((error) => {
        console.error('Error fetching BBS view files:', error);
      });
  };

  // const handleBbsClick = (bbs, projectCode, type) => {
  //   console.log('BBS Clicked@@@@@@:', bbs); // Log the clicked BBS data
  //   console.log('BBS ProjectCode:', projectCode); // Log the clicked BBS data
  //   setSelectedBbs({ bbs, projectCode }); // Store the clicked BBS data
  //   //console.log('selectedBbs immediately after setSelectedBbs:', selectedBbs);
  //   //setIsModalVisible(true); // Show the modal

  //   const params = {
  //     bbsId: bbs,
  //     project_code: projectCode,
  //     // bbsId: '2526BBS140',
  //     // project_code: 'Pro-001', // Assuming project_code is part of the `bbs` object
  //     type,
  //   };
  //   console.log('params: ', params);

  //   dispatch(getBBSViewFiles(params))
  //     .then((res) => {
  //       console.log('BBS Algorithm Result:', res.payload);
  //       if (res.payload?.success) {
  //         const { results } = res.payload; // Extract `results` array from response
  //         //setDataToSend({results,bbs_id}); // Store `results` in `dataToSend`
  //         //console.log('Results stored in dataToSend:', results);

  //         const { data } = res.payload;
  //         setConsolidatedData(data);

  //         if (type === 'consolidated-data') {
  //           const { formattedData } = res.payload;
  //           handleDownload(formattedData, bbs);
  //         }

  //         if (type === 'raw-data') {
  //           // Call the export function for raw data
  //           optimizeAlgorithmExport(results, bbs); // Pass results to export function
  //         }
  //       } else {
  //         console.error('Backend response does not indicate success.');
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching BBS view files:', error);
  //     });
  // };

  const handleBbsClick = async (bbs, projectCode, type) => {
    setDownloading(type); // Start loader

    const params = {
      bbsId: bbs,
      project_code: projectCode,
      type,
    };

    try {
      const res = await dispatch(getBBSViewFiles(params));

      if (res.payload?.success) {
        const { results, data, formattedData } = res.payload;

        setConsolidatedData(data);

        if (type === 'consolidated-data') {
          handleDownload(formattedData, bbs);
        }

        if (type === 'raw-data') {
          optimizeAlgorithmExport(results, bbs);
        }
      } else {
        console.error('Backend said it failed.');
      }
    } catch (err) {
      console.error('Error:', err);
    } finally {
      setDownloading(''); // Stop loader
    }
  };

  console.log('datatosend to pdf: ', dataToSend);

  // const handle_PdfDownload_cuttingPattern = async (bbsId,projectCode) => {
  //   setPdfDownloadLoading(true);
  //   const Url = process.env.REACT_APP_API_URL;
  //   const apiUrl = `${Url}/pdf/download`;

  //   const payload = {
  //     bbs_id:bbsId,
  //     project_code: projectCode,
  //   };

  //   console.log('hree inside the pdfdownload: ',payload)
  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!response.ok) {
  //       throw new Error('Failed to download PDF');
  //     }

  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);

  //     // Create a temporary link element for downloading
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.download = 'downloaded_file.pdf'; // Set the default file name
  //     document.body.appendChild(link);
  //     link.click();

  //     // Clean up
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //     setPdfDownloadLoading(false);
  //     message.success('PDF downloaded successfully.');
  //   } catch (error) {
  //     setPdfDownloadLoading(false);
  //     message.error('Failed to download PDF');
  //     console.error('Error downloading PDF:', error);
  //   }
  // };
  const handle_PdfDownload_cuttingPattern = async (bbsId, projectCode) => {
    setPdfDownloadLoading(true);
    const Url = process.env.REACT_APP_API_URL;

    // Create URL with parameters
    const params = new URLSearchParams({
      bbs_id: bbsId,
      project_code: projectCode,
    });
    const apiUrl = `${Url}/pdf/download?${params}`;
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download PDF');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element for downloading
      const link = document.createElement('a');
      link.href = url;
      link.download = `${bbsId}_Cutting Pattern.pdf`;
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url);
      setPdfDownloadLoading(false);
      message.success('Cutting pattern downloaded successfully');
    } catch (error) {
      setPdfDownloadLoading(false);
      message.error('Failed to download PDF');
      console.error('Error downloading PDF:', error);
    }
  };

  // useEffect(() => {
  //   console.log('Updated selectedBbs:', selectedBbs);
  // }, [selectedBbs]);

  console.log('consolidate_data outside: ', consolidatedData);
  const handleDownload = (formattedData, bbs) => {
    if (!formattedData || formattedData.length === 0) {
      console.error('No data to download.');
      return;
    }

    console.log('Formatted Data Passed to Download:', formattedData);

    // Create a worksheet from the data
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Consolidated Data');

    // Trigger download of the workbook
    XLSX.writeFile(workbook, `${bbs}_Consolidated Data.xlsx`);
  };

  const handleUploadDownload = (file) => {
    // Use the file path directly

    const fileUrl = file.path;
    console.log('fileurl: ', fileUrl);

    // Check if the file URL exists
    if (fileUrl) {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = file.originalname || 'downloaded-file.xlsx'; // Use original file name if available
      document.body.appendChild(link); // Append the link to the DOM
      link.click(); // Trigger the download
      document.body.removeChild(link); // Remove the link from the DOM
    } else {
      console.error('File URL not available for download');
    }
  };

  // const downloadFinalBBSSummary = async (bbs) => {
  //   try {
  //     const response = await fetch(
  //       `${apiUrl}/bbs/output-file?bbs_id=${bbs}`,
  //       {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type':
  //             'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Optional
  //         },
  //       },
  //     );

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }

  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);

  //     // Create a temporary anchor element
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `${bbs}_Final BBS Summary.xlsx`; // Adjust the file name as needed
  //     document.body.appendChild(a);
  //     a.click();

  //     // Cleanup
  //     window.URL.revokeObjectURL(url);
  //     document.body.removeChild(a);
  //   } catch (error) {
  //     console.error('Error downloading the file:', error);
  //   }
  // };

  const downloadFinalBBSSummary = async (bbs) => {
    setDownloading('final'); // Start loader
    try {
      const response = await fetch(`${apiUrl}/bbs/output-file?bbs_id=${bbs}`, {
        method: 'GET',
        headers: {
          'Content-Type':
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${bbs}_Final BBS Summary.xlsx`;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the file:', error);
    } finally {
      setDownloading(''); // Stop loader
    }
  };

  const downloadMappingSheet = async (bbs) => {
    try {
      const response = await fetch(`${apiUrl}/bbs/mapping-file?bbs_id=${bbs}`, {
        method: 'GET',
        headers: {
          'Content-Type':
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Optional
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = `${bbs}_Mapping Sheet.xlsx`; // Adjust the file name as needed
      document.body.appendChild(a);
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  };

  const downloadInputFiles = async (blobName, fullFilename,index) => {
    setDownloadingIndex(index);
    try {
      const token = localStorage.getItem('token');
      console.log('token received: ', token);

      const response = await fetch(
        `${apiUrl}/bbs/input-files?blobName=${blobName}`,
        {
          method: 'GET',
          headers: {
            'Content-Type':
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Optional
            // Authorization: `Bearer ${token}`, // Add Authorization token
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fullFilename}`; // Adjust the file name as needed
      document.body.appendChild(a);
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the file:', error);
    } finally {
      setDownloadingIndex(null);
    }
  };

  const VisualizationBar = ({ data }) => {
    const total = data.reduce((sum, item) => sum + item.value, 0); // Calculate the total value

    return (
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '36px',
          borderRadius: '20px',
          overflow: 'hidden',
        }}
      >
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: item.color, // Assign color for each segment
              width: `${(item.value / total) * 100}%`, // Calculate width as percentage
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 'bold',
            }}
          >
            {item.value}
          </div>
        ))}
      </div>
    );
  };

  const dataSource1 = [
    {
      key: '1',
      size: 50,
      repitition: 20,
      visualizationData: [
        { label: 'A', value: 40, color: '#FFB0B0' },
        { label: 'B', value: 30, color: '#FFD09B' },
        { label: 'C', value: 30, color: '#FFECC8' },
      ],
    },
    {
      key: '1',
      size: 50,
      repitition: 20,
      visualizationData: [
        { label: 'A', value: 10, color: '#FFB0B0' },
        { label: 'B', value: 30, color: '#FFD09B' },
        { label: 'C', value: 30, color: '#FFECC8' },
      ],
    },
    {
      key: '1',
      size: 50,
      repitition: 20,
      visualizationData: [
        { label: 'A', value: 40, color: '#FFB0B0' },
        { label: 'B', value: 30, color: '#FFD09B' },
        { label: 'C', value: 30, color: '#FFECC8' },
      ],
    },
    {
      key: '2',
      size: 25,
      repitition: 32,
      visualizationData: [
        { label: 'A', value: 30, color: '#FFB0B0' },
        { label: 'B', value: 50, color: '#FFD09B' },
        { label: 'C', value: 10, color: '#FFECC8' },
        { label: 'D', value: 10, color: '#FFF7D1' },
      ],
    },
  ];

  const columns1 = [
    {
      title: 'Size (In MM)',
      dataIndex: 'size',
      key: 'size',
      width: '60px',
      ellipsis: true,
    },
    {
      title: 'Repitition',
      dataIndex: 'repitition',
      key: 'repitition',
      width: '60px',
      ellipsis: true,
    },

    {
      title: 'Cutting Pattern',
      key: 'visualization',
      width: '250px',
      ellipsis: true,
      render: (_, record) => (
        <VisualizationBar data={record.visualizationData} />
      ),
    },
  ];

  useEffect(() => {
    console.log('ViewBBS ID:', id); // Log the ID for verification
    // Fetch additional data if needed based on ID
  }, [id]);

  const dummyData = [
    {
      key: '1',
      project_code: 'PC001',
      project_name: 'Project One',
      status: 'Active',
    },
    {
      key: '2',
      project_code: 'PC002',
      project_name: 'Project Two',
      status: 'Inactive',
    },
    {
      key: '3',
      project_code: 'PC003',
      project_name: 'Project Three',
      status: 'Active',
    },
    {
      key: '4',
      project_code: 'PC004',
      project_name: 'Project Four',
      status: 'Completed',
    },
  ];

  // Columns for the table
  const columns = [
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Code
        </span>
      ),
      key: 'project_code',
      dataIndex: 'project_code', // Unique key for column
      ellipsis: true,
      render: (text, record) => {
        console.log('record: ', record); // To check the structure of record
        return (
          <div className="text-[#667085] text-[12px] font-['SF-Pro-Text-Regular, sans-serif'] ml-[8px]">
            {record?.RequestApproval?.project_code || 'N/A'}
          </div>
        );
      },
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Name
        </span>
      ),
      key: 'project_name',
      dataIndex: 'project_name', // Unique key for column
      ellipsis: true,
      render: (text, record) => {
        console.log('record: ', record); // To check the structure of record
        return (
          <div className="text-[#667085] text-[12px] font-['SF-Pro-Text-Regular, sans-serif'] ml-[8px]">
            {record?.RequestApproval?.project_name || 'N/A'}
          </div>
        );
      },
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Existing BBS
        </span>
      ),
      dataIndex: 'BBs', // The array in bbsList
      key: 'BBs',
      width: '160px',
      ellipsis: true,
      render: (BBs, record) => {
        const project_code = record?.RequestApproval?.project_code;
        const bbsArray = record?.RequestApproval?.BBs || [];
        const displayBbs = bbsArray.slice(0, 4); // Get the first 4 bbs_id
        const remainingBbsArray = bbsArray.slice(4); // Remaining BBS
        const remainingCount = remainingBbsArray.length; // Count the remaining bbs_id

        // State to track if remaining items are visible

        return (
          <span
            style={{
              marginLeft: '7px',
              color: '#0092DD',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              flexWrap: 'wrap',
              gap: '5px',
            }}
          >
            {displayBbs.map((bbs, index) => (
              <div key={index}>
                {bbs?.is_optimised === true ? (
                  <a
                    style={{
                      textDecoration: 'underline',
                      color: '#0092DD',
                      display: 'block',
                    }}
                    onClick={() =>
                      handleBbsClick1(
                        bbs.bbs_id,
                        record.RequestApproval.project_code,
                      )
                    }
                  >
                    {bbs?.bbs_id || 'N/A'}
                  </a>
                ) : (
                  <span
                    style={{
                      textDecoration: 'underline',
                      color: 'red',
                      display: 'block',
                      cursor: 'pointer',
                    }}
                    onClick={() =>
                      handleBbsClick1(
                        bbs.bbs_id,
                        record.RequestApproval.project_code,
                      )
                    }
                  >
                    {bbs?.bbs_id || 'N/A'}
                  </span>
                )}
              </div>
            ))}

            {/* Show remaining count */}
            {remainingCount > 0 && (
              <a
                onClick={toggleRemaining}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '5px',
                  color: '#667085',
                  fontSize: '12px',
                  cursor: 'pointer',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px',
                    height: '17px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                    color: '#0092DD',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    marginRight: '4px',
                    border: '1px solid #EAECF0',
                  }}
                >
                  +{remainingCount}
                </span>
              </a>
            )}

            {/* Render remaining items if expanded */}
            {showRemaining &&
              remainingBbsArray.map((bbs, index) => (
                <a
                  key={`remaining-${index}`}
                  style={{
                    textDecoration: 'underline',
                    color: '#0092DD',
                    display: 'block',
                  }}
                  onClick={() =>
                    handleBbsClick1(
                      bbs.bbs_id,
                      record.RequestApproval.project_code,
                    )
                  }
                >
                  {bbs?.bbs_id || 'N/A'}
                </a>
              ))}
          </span>
        );
      },
    },

    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Quantity Optimized (in MT)
        </span>
      ),
      dataIndex: 'RequestApproval', // Adjusted to reflect the correct data structure
      key: 'quantity',
      ellipsis: true,
      render: (RequestApproval, record) => {
        const projectCode = record?.RequestApproval?.project_code;
        const BBs = RequestApproval?.BBs || []; // Extract BBs array

        // Calculate the total quantity from the Summaries array
        const totalQuantities = BBs.map((bbs) =>
          (bbs?.Summaries || []).reduce(
            (sum, summary) => sum + (summary.quantity || 0),
            0,
          ),
        );

        const displayTonnage = totalQuantities.slice(0, 4); // Show first 4 summed values
        const remainingTonnage = totalQuantities.slice(4); // Remaining summed values
        const remainingCount = remainingTonnage.length; // Count the remaining tonnage

        // Toggle the remaining tonnage visibility

        return (
          <span
            style={{
              marginLeft: '7px',
              color: '#667085',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            {/* Display first 4 Tonnage */}
            {displayTonnage.map((sum, index) => (
              <span key={index} style={{ marginLeft: '8px' }}>
                {sum.toFixed(2) || 'N/A'}{' '}
                {/* Display sum with 2 decimal places */}
              </span>
            ))}

            {/* Show remaining count */}
            {remainingCount > 0 && (
              <span
                onClick={() => toggleRemaining(projectCode)}
                style={{
                  display: 'flex',
                  alignItems: 'end',
                  justifyContent: 'center',
                  color: '#667085',
                  fontSize: '12px',
                  cursor: 'pointer',
                  marginTop: '-21px',
                  marginLeft: '60px',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px',
                    height: '17px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                    color: '#0092DD',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    border: '1px solid #EAECF0',
                    marginRight: '4px',
                  }}
                >
                  +{remainingCount}
                </span>
              </span>
            )}

            {/* Render remaining tonnage if expanded */}
            {showRemaining &&
              remainingTonnage.map((sum, index) => (
                <span
                  key={`remaining-${projectCode}-${index}`}
                  style={{ marginLeft: '8px' }}
                >
                  {sum.toFixed(2) || 'N/A'}
                </span>
              ))}
          </span>
        );
      },
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Wastage (%)
        </span>
      ),
      dataIndex: 'RequestApproval',
      key: 'wastagePer',
      ellipsis: true,
      render: (RequestApproval, record) => {
        const projectCode = record?.RequestApproval?.project_code;
        const BBs = RequestApproval?.BBs || []; // Ensure BBs is defined

        // Calculate wastage for each BBS ID
        const calculatedWastage = BBs.map((bbs) => {
          const summaries = bbs?.Summaries || []; // Get summaries array

          // Calculate total wastage for this BBS ID
          const totalWastage = summaries.reduce(
            (acc, item) => acc + item.proportion * item.offcut,
            0,
          );

          return {
            ...bbs,
            wastagePer: totalWastage.toFixed(2), // Format to 2 decimal places
          };
        });

        const displayWastage = calculatedWastage.slice(0, 4); // Show first 4 wastage values
        const remainingWastage = calculatedWastage.slice(4); // Remaining wastage values
        const remainingCount = remainingWastage.length; // Count the remaining wastage

        return (
          <div
            style={{
              color: '#667085',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            {/* Display first 4 Wastage values */}
            {displayWastage.map((bbs, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  gap: '3px',
                  marginLeft: '7px',
                }}
              >
                <span style={{ color: '#667085' }}>{bbs.wastagePer}%</span>
              </div>
            ))}

            {/* Show remaining count beside the last wastage */}
            {remainingCount > 0 && (
              <span
                onClick={() => toggleRemaining(projectCode)}
                style={{
                  display: 'flex',
                  alignItems: 'end',
                  justifyContent: 'center',
                  color: '#667085',
                  fontSize: '12px',
                  cursor: 'pointer',
                  marginTop: '-21px',
                  marginLeft: '60px',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px',
                    height: '17px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                    color: '#0092DD',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    border: '1px solid #EAECF0',
                    marginLeft: '4px',
                  }}
                >
                  +{remainingCount}
                </span>
              </span>
            )}

            {/* Render remaining wastage values if expanded */}
            {showRemaining &&
              remainingWastage.map((bbs, index) => (
                <div
                  key={`remaining-${projectCode}-${index}`}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    gap: '3px',
                    marginLeft: '7px',
                  }}
                >
                  <span style={{ color: '#667085' }}>{bbs.wastagePer}%</span>
                </div>
              ))}
          </div>
        );
      },
    },

    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Optimized By
        </span>
      ),
      dataIndex: 'RequestApproval',
      key: 'givenName',
      ellipsis: true,
      render: (RequestApproval) => {
        const BBs = RequestApproval?.BBs || []; // Ensure BBs is defined
        const displayOptimizedBy = BBs.slice(0, 4); // Show first 4 entries
        const remainingOptimizedBy = BBs.slice(4); // Remaining optimized by entries
        const remainingCount = remainingOptimizedBy.length; // Count the remaining entries

        return (
          <div
            style={{
              color: '#667085',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            {/* Display first 4 Optimized By values */}
            {displayOptimizedBy.map((bbs, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  gap: '3px',
                  marginLeft: '8px',
                }}
              >
                <span style={{ color: '#667085' }}>
                  {bbs?.User?.givenName || 'N/A'}
                </span>
              </div>
            ))}

            {/* Show remaining count beside the last Optimized By */}
            {remainingCount > 0 && (
              <span
                onClick={toggleRemaining}
                style={{
                  display: 'flex',
                  alignItems: 'end',
                  justifyContent: 'center',
                  color: '#667085',
                  fontSize: '12px',
                  cursor: 'pointer',
                  marginLeft: '60px',
                  marginTop: '-21px',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px',
                    height: '17px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                    color: '#0092DD',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    border: '1px solid #EAECF0',
                    marginLeft: '4px',
                  }}
                >
                  +{remainingCount}
                </span>
              </span>
            )}

            {/* Render remaining Optimized By values if expanded */}
            {showRemaining &&
              remainingOptimizedBy.map((bbs, index) => (
                <div
                  key={`remaining-${index}`}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    gap: '3px',
                    marginLeft: '8px',
                  }}
                >
                  <span style={{ color: '#667085' }}>
                    {bbs?.User?.givenName || 'N/A'}
                  </span>
                </div>
              ))}
          </div>
        );
      },
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Date
        </span>
      ),
      dataIndex: 'RequestApproval',
      key: 'optimizationDates',
      ellipsis: true,
      render: (RequestApproval) => {
        const BBs = RequestApproval?.BBs || []; // Ensure BBs is defined
        const displayOptimizationDate = BBs.slice(0, 4); // Show first 4 entries
        const remainingOptimizationDate = BBs.slice(4); // Remaining optimization date entries
        const remainingCount = remainingOptimizationDate.length; // Count the remaining entries

        return (
          <div
            style={{
              color: '#667085',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            {/* Display first 4 Optimization Dates */}
            {displayOptimizationDate.map((bbs, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  gap: '10px',
                  marginLeft: '8px',
                }}
              >
                <span style={{ color: '#667085' }}>
                  {bbs?.optimization_date
                    ? new Date(bbs.optimization_date).toLocaleDateString()
                    : 'N/A'}
                </span>
              </div>
            ))}

            {/* Show remaining count beside the last Optimization Date */}
            {remainingCount > 0 && (
              <span
                onClick={toggleRemaining}
                style={{
                  display: 'flex',
                  alignItems: 'end',
                  justifyContent: 'center',
                  color: '#667085',
                  fontSize: '12px',
                  cursor: 'pointer',
                  marginLeft: '60px',
                  marginTop: '-21px',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px',
                    height: '17px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                    color: '#0092DD',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    border: '1px solid #EAECF0',
                    marginLeft: '4px',
                  }}
                >
                  +{remainingCount}
                </span>
              </span>
            )}

            {/* Render remaining Optimization Dates if expanded */}
            {showRemaining &&
              remainingOptimizationDate.map((bbs, index) => (
                <div
                  key={`remaining-${index}`}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    gap: '10px',
                    marginLeft: '8px',
                  }}
                >
                  <span style={{ color: '#667085' }}>
                    {bbs?.optimization_date
                      ? new Date(bbs.optimization_date).toLocaleDateString()
                      : 'N/A'}
                  </span>
                </div>
              ))}
          </div>
        );
      },
    },
  ];

  const handleBBS = () => {
    //setIsExistingBBS(false);
    const payload = {
      userId: user_details?.user?.id, // Pass the user ID
      page: currpage, // Current page
    };
    dispatch(getApproverDashboard(payload));
  };

  useEffect(() => {
    dispatch(getBBSView({ id }));
  }, [dispatch, id]);

  console.log('bbs-view in view page: ', BBSView);

  // useEffect(() => {
  //   if (user_details?.user?.id) {
  //     const payload = {
  //       userId: user_details?.user?.id, // Use the actual user ID here
  //       page: currpage, // Current page for pagination
  //     };
  //     //dispatch(getApproverDashboard(payload));
  //   }
  // }, [dispatch, user_details?.user?.id,currpage]);

  return (
    <div className="main-div">
      <div className="flex flex-col items-center p-10">
        <Table
          dataSource={dataSource} // Pass the dummy data to the table
          columns={columns} // Pass the columns for the table
          bordered
          loading={{
            spinning: loading, // Spinner controlled by Redux loading state
            indicator: <Spin size="large" />, // Custom large spinner
          }}
          pagination={false}
          style={{ width: '100%' }}
          scroll={{ x: 'max-content' }}
          className="responsive-table" /* {{ total: dummyData.length }}*/
        />
        <Button
          onClick={() => navigate('/dashboard')}
          className="prev-button w-[100px] justify-center items-center mt-5"
        >
          Back
        </Button>
      </div>

      <Modal
        open={isModalVisible}
        onOk={handleConfirm}
        onCancel={handleCancel}
        footer={[
          <div className="flex justify-center gap-1 mt-3" key="footer-buttons">
            <Button
              className="custom-cancel-btn rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#344054] md:w-[170px] w-auto"
              key="cancel"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              className="custom-vis-btn bg-[#1C4E9D] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#FFFFFF] md:w-[190px] w-auto"
              key="download"
              type="primary"
              onClick={() => downloadMappingSheet(selectedBbs?.bbs)}
            >
              Download Mapping Sheet
            </Button>
          </div>,
        ]}
        style={{ zIndex: 1050 }}
        title={null}
        width={1050}
      >
        {/* <p className="mb-2 font-semibold">Input File(s):</p> */}
        <div className="flex">
          {inputFiles?.length > 0 ? (
            <ul className="flex gap-2">
  {inputFiles.map((file, index) => {
    try {
      const parsedFile = typeof file === 'string' ? JSON.parse(file) : file;
      const blobName = parsedFile.uploadedUrl;
      const fullFilename =
        parsedFile.originalName ||
        parsedFile.filename ||
        'Unknown File';

      const isDownloading = downloadingIndex === index;
      const truncatedFilename =
        fullFilename.length > 12
          ? `${fullFilename.substring(0, 12)}...`
          : fullFilename;

      return (
        <li key={index}>
          <div
            onClick={() =>
              isDownloading
                ? null
                : downloadInputFiles(blobName, fullFilename, index)
            }
            className={`cursor-pointer w-[219px] flex gap-4 p-[10px] border-[1px] border-[#EAECF0] rounded h-[47px] items-center ${
              isDownloading ? 'opacity-50 pointer-events-none' : ''
            }`}
          >
            <img
              className="h-[20px] w-[20px]"
              src={excel_icon}
              alt="Excel Icon"
            />
            <p
              className="text-[#344054] text-[11px] font-medium truncate"
              title={fullFilename}
            >
              {isDownloading ? 'Downloading...' : truncatedFilename}
            </p>
            <img
              className="ml-5 mt-2 h-[18px] w-[18px]"
              src={button_icon}
              alt="Download Icon"
            />
          </div>
        </li>
      );
    } catch (error) {
      console.error('Error parsing file:', error);
      return null;
    }
  })}
</ul>
          ) : null}
        </div>
        <div className="flex flex-col gap-4 mt-0 xl:mt-3 xl:flex xl:flex-row xl:gap-2">
          {['Consolidated Data', 'Raw Optimized Data', 'Final BBS Summary'].map(
            (text) => {
              const typeMap = {
                'Consolidated Data': 'consolidated-data',
                'Raw Optimized Data': 'raw-data',
                'Final BBS Summary': 'final',
              };

              const currentType = typeMap[text];
              const isLoading = downloading === currentType;

              return (
                <div
                  key={text}
                  onClick={() => {
                    if (isLoading) return; // Prevent double click

                    if (currentType === 'final') {
                      downloadFinalBBSSummary(selectedBbs?.bbs);
                    } else {
                      handleBbsClick(
                        selectedBbs?.bbs,
                        selectedBbs?.projectCode,
                        currentType,
                      );
                    }
                  }}
                  className={`cursor-pointer w-[219px] flex gap-4 p-[10px] border rounded h-[47px] items-center ${
                    isLoading ? 'opacity-50 pointer-events-none' : ''
                  }`}
                >
                  <img className="h-[20px] w-[20px]" src={excel_icon} />
                  <p className="text-[#344054] text-[11px] font-medium">
                    {isLoading ? 'Downloading...' : text}
                  </p>
                  <img
                    className="ml-5 mt-2 h-[18px] w-[18px]"
                    src={button_icon}
                  />
                </div>
              );
            },
          )}
        </div>
        {console.log('datatoSend123: ', dataToSend)}
        {console.log('hellojusttocheck: ', selectedBbs?.bbs)}
        <div className="flex justify-end mb-6 mt-7">
          <Button
            onClick={() =>
              handle_PdfDownload_cuttingPattern(
                selectedBbs?.bbs,
                selectedBbs?.projectCode,
              )
            }
            loading={pdfDownloadLoading}
            className="custom-vis-btn text-[#344054] font-['SF-Pro-Text-Regular, sans-serif'] text-[14px]"
          >
            <img src={pdf_image} alt="PDF" className="mr-2" />
            Download cutting pattern
          </Button>
        </div>
        {console.log('bbs-algorithm-result: in viewpage: ', results)}
        <div style={{ marginTop: '20px' }}>
          <VisualizationTable bbsAlgorithmResult={results} />
        </div>
      </Modal>
    </div>
  );
};

export default ViewBBS;
